"use client";

import Email from "./Email";
// import dynamic from "next/dynamic";

type ActionableToolsProps = {
  itinerary: string;
  city: string;
  itinid: string;
};

export default function ActionableTools({
  itinerary,
  city,
  itinid,
}: ActionableToolsProps) {
  // const DownloadPDF = dynamic(() => import("./DownloadPDF"), {
  //   ssr: false,
  // });

  return (
    <div className="flex justify-center">
      <div className="flex flex-col space-y-2 max-w-96 md:flex-row md:space-y-0 md:space-x-4">
        <Email itinerary={itinerary} city={city} itinid={itinid} />
        {/* PDF download functionality could be added here */}
      </div>
    </div>
  );
}
